import type {Dispatch} from 'react'

import Select from '@/components/Select/Select'

import style from './RestaurantSorter.module.scss'

export enum SortBy {
  Recommend = 'Recommend',
  RestaurantName = 'RestaurantName',
  PriceAsc = 'PriceAsc',
  PriceDesc = 'PriceDesc',
  Rating = 'Rating',
  Distance = 'Distance',
  DeliveryEstimate = 'DeliveryEstimate',
  DeliveryMinimum = 'DeliveryMinimum',
}

interface Props {
  sorter: SortBy
  setSorter: Dispatch<SortBy>
}

const OPTIONS = [
  {
    label: 'Recommend',
    value: SortBy.Recommend,
  },
  {
    label: 'Restaurant Name',
    value: SortBy.RestaurantName,
  },
  {
    label: 'Price (low to high)',
    value: SortBy.PriceAsc,
  },
  {
    label: 'Price (high to low)',
    value: SortBy.PriceDesc,
  },
  {
    label: 'Rating',
    value: SortBy.Rating,
  },
  {
    label: 'Distance',
    value: SortBy.Distance,
  },
  {
    label: 'Delivery Estimate',
    value: SortBy.DeliveryEstimate,
  },
  {
    label: 'Delivery Minimum',
    value: SortBy.DeliveryMinimum,
  },
]

export default memo<Props>(function RestaurantSorter({sorter, setSorter}) {
  return (
    <Select
      className={style.Select}
      buttonProps={{className: style.Button}}
      popoverProps={{className: style.Popover}}
      prefix={<span aria-hidden>Sort by:</span>}
      label='Sort by'
      options={OPTIONS}
      selectedItem={sorter}
      setSelectedItem={setSorter}
    />
  )
})
